/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Custom code to handle inline discount label with price
document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant;

  // Find the price list wrapper container
  var priceListWrapper = document.querySelector('.price-list-wrapper.price-list--with-discount');
  if (!priceListWrapper) return;

  // Find or create the discount label
  var discountLabel = priceListWrapper.querySelector('.product-label--on-sale');

  // Check if variant has a discount
  if (variant && variant.compare_at_price && variant.price < variant.compare_at_price) {
    // Calculate savings
    var savings;
    if (window.theme.discountMode === 'percentage') {
      savings = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price) + '%';
    } else {
      var savingsAmount = Currency.formatMoney(variant.compare_at_price - variant.price, window.theme.moneyFormat);
      savings = '<span>' + savingsAmount + '</span>';
    }

    // If discount label doesn't exist, create it
    if (!discountLabel) {
      discountLabel = document.createElement('span');
      discountLabel.className = 'product-label product-label--on-sale product-label--inline';
      priceListWrapper.appendChild(discountLabel);
    }

    // Update the discount label text
    discountLabel.innerHTML = window.languages.collectionOnSaleLabel.replace('{{savings}}', savings);
    discountLabel.style.display = 'inline-block';
  } else {
    // Hide discount label if no discount
    if (discountLabel) {
      discountLabel.style.display = 'none';
    }
  }
});

